var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("form", [
      _c("div", { staticClass: "dashboard-page-title" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("h1", [_vm._v("Profile Image & Marketing Photos")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-info",
              attrs: { "active-class": "" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-chevron-left" }),
              _vm._v(" Back\n          "),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "dashboard-block" }, [
          _c("h2", [_vm._v("Profile Picture")]),
          _vm._v(" "),
          _c("div", { staticClass: "panel panel-default" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", { staticClass: "form-horizontal" }, [
                    _c(
                      "div",
                      {
                        class: ["form-group", _vm.errorClass("profile_image")],
                      },
                      [
                        _c("label", { staticClass: "control-label col-sm-4" }, [
                          _vm._v("Upload Image"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-8" },
                          [
                            _c("div", { staticClass: "file-upload-control" }, [
                              _c("input", {
                                attrs: {
                                  name: "profile_image",
                                  id: "profile_image",
                                  type: "file",
                                },
                                on: {
                                  change: _vm.handleFileSelectionCallback,
                                  input: _vm.handleFileSelectionCallback,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "btn btn-default btn-block",
                                  attrs: { for: "profile_image" },
                                },
                                [_vm._v("Select Profile Picture")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "help-block" }, [
                              _vm._v(
                                "For best results images should be 512px by 512px."
                              ),
                            ]),
                            _vm._v(" "),
                            _c("help-block", {
                              attrs: { field: "profile_image" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", { staticStyle: { width: "100%" } }, [
                    _c("img", {
                      attrs: {
                        id: "profile-image-crop",
                        src: _vm.userProfileImageOriginalUrl,
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-footer flex justify-between items-center" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "submit",
                      click: _vm.handleSaveProfileImageCallback,
                    },
                  },
                  [
                    _vm._v(
                      "\n                Save Profile Picture\n              "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      href: _vm.userProfileImageOriginalUrl,
                      target: "_blank",
                      download: "",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-cloud-download fa-lg",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(3, function (i) {
          return _c(
            "div",
            { key: i, staticClass: "col-xs-12 col-sm-4 margin-tb" },
            [
              _c("talent-marketing-photo", {
                key: i,
                attrs: { index: i, image: _vm.images[i - 1] },
                on: {
                  upload: (photo) => {
                    _vm.images.push(photo)
                  },
                  delete: () => {
                    _vm.images.splice(i - 1, 1)
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _vm._v("Marketing Photos"),
      _c("br"),
      _vm._v(" "),
      _c("small", { staticClass: "subtext" }, [
        _vm._v(
          "Upload three professional photos that clients can use for event and marketing promotions. Please ensure these images are not branded in team/club attire and you have the required permissions to allow clients to use these photos."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }